import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import SizesMap, { defaultSize, sizes } from './Input.text.sizes'
import { colors } from '../../../constants'

const Input = styled.input`
    background: ${colors.greylightest};
    ${({ borderColor }) => (borderColor ? `border: 1px solid ${borderColor};` : `border: 1px solid ${colors.greylight};`)}
    border-radius: 3px;
    outline: none;
    padding: 5px;

    &:active,
    &:focus,
    &:hover {
        border: 1px solid ${colors.grey};
    }

    ${({ error }) =>
        error &&
        `
    border: 1px solid ${colors.red};
  `}

    ${({ size }) => {
        switch (size) {
            case SizesMap.sm:
                return 'width: 115px;'
            case SizesMap.md:
                return 'width: 260px;'
            case SizesMap.lg:
                return 'width: 400px;'
            case SizesMap.xl:
                return 'width: 520px'
            case SizesMap.none:
            default:
                return ''
        }
    }}
`

const InputText = React.forwardRef(({ onChange, size, value, ...props }, ref) => (
    <Input type="text" onChange={onChange} ref={ref} size={size} value={value || ''} {...props} />
))

InputText.propTypes = {
    onChange: PropTypes.func,
    size: PropTypes.oneOf(sizes),
    value: PropTypes.string,
}

InputText.defaultProps = {
    onChange: () => null,
    size: defaultSize,
    value: '',
}

export default InputText
